import React from "react";

import { useExperience } from "@/context/ExperienceContext";
import { Language } from "@/types/Language";

export const useAvailableLanguages = () => {
  const { alternates = [], language, country: countryCode } = useExperience();

  const availableLanguages = React.useMemo(() => {
    const languagesSet = new Set<Language>();

    alternates.forEach((alt) => {
      if (alt.language && alt.language !== language && alt.country === countryCode) {
        languagesSet.add(alt.language);
      }
    });

    return languagesSet;
  }, [alternates, language, countryCode]);

  return availableLanguages;
};
